// src/utils/roles.ts
// Mô hình phân quyền: TẤT CẢ user (chủ nhà lẫn người thuê) đều đăng nhập bằng
// Google. Người thuê tự đăng ký (xem HomePage.tsx -> tenantRegistrations),
// chủ nhà duyệt theo phòng (xem PermissionsPage.tsx) rồi mới có role 'tenant'
// + roomId trong userRoles/{email}. Việc chặn theo role/roomId được enforce
// thật ở server bằng database.rules.json - code ở đây chỉ là UI-level gating.

export type Role = 'admin' | 'manager' | 'viewer' | 'tenant';

// Admin gốc: luôn có toàn quyền, kể cả khi node userRoles trống (dùng để bootstrap).
export const SUPER_ADMIN_EMAILS = ['bttvn.4t@gmail.com'];

export const ROLE_LABELS: Record<Role, string> = {
    admin: 'Admin',
    manager: 'Quản lý',
    viewer: 'Chỉ xem',
    tenant: 'Người thuê',
};

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
    admin: 'Toàn quyền: ghi điện nước, quản lý phòng, cài đặt giá và phân quyền.',
    manager: 'Ghi điện nước, duyệt & thu tiền, quản lý phòng, duyệt người thuê vào phòng. Không thêm/xoá phòng, không cấp quyền chủ nhà.',
    viewer: 'Chỉ xem số liệu và hoá đơn, không chỉnh sửa.',
    tenant: 'Chỉ xem điện nước của phòng đang thuê.',
};

export const ROLE_ORDER: Role[] = ['admin', 'manager', 'viewer', 'tenant'];

export const isRole = (value: unknown): value is Role =>
    value === 'admin' || value === 'manager' || value === 'viewer' || value === 'tenant';

export const isSuperAdmin = (email?: string | null): boolean =>
    !!email && SUPER_ADMIN_EMAILS.includes(email.trim().toLowerCase());

// RTDB keys không được chứa '.', '#', '$', '[', ']', '/'. Email chỉ cần đổi '.' -> ','.
export const sanitizeEmail = (email: string): string =>
    email.trim().toLowerCase().replace(/\./g, ',');
